// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"32":"08b5e03a","214":"9c8bf7d3","378":"d6f41eb2","796":"52b7eb5a","999":"c02dca3a"}[chunkId] + ".css";
};